import React, { Suspense, lazy } from 'react';
import type { CustomField } from '@puckeditor/core';

export type CollectionPickerFieldProps = {
  field: { label?: string };
  name: string;
  readOnly?: boolean;
};

// Lazy so `@apollo/client` and the generated collections document stay out of the storefront
// bundle. `carousel-types.ts` (and through it `product-carousel.tsx`) is reachable from the
// production renderer, so a static import would ship an Apollo client to every shopper viewing a
// published CMS page even though only the editor can render this field. Mirrors
// `brand-picker-field.tsx`; `bundle-boundaries.test.ts`'s static-only walk is what enforces it.
const CollectionPickerWidget = lazy(() => import('./collection-picker-widget'));

function CollectionPickerFieldRender(props: CollectionPickerFieldProps): JSX.Element {
  return (
    <Suspense fallback={null}>
      <CollectionPickerWidget {...props} />
    </Suspense>
  );
}

/**
 * Puck `custom` field for choosing one of the previewed store's collections.
 *
 * Bound to `collectionSlug`. On selection the widget also writes `collectionTitle` in the same
 * dispatch so heading derivation stays synchronous without a second query.
 *
 * `ai.exclude` because the collection list is per-store live data the AI plugin cannot enumerate;
 * an author picks from the real list instead.
 */
export const collectionPickerField: CustomField<string> = {
  type: 'custom',
  label: 'Collection',
  render: CollectionPickerFieldRender as CustomField<string>['render'],
  ai: { exclude: true },
};
